import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, MailOpen, Trash2, Building2 } from "lucide-react";
import api from "../../lib/api";

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const res = await api.get("/contact-messages");
      setMessages(res.data);
    } catch (e) {
      toast.error("Error al cargar mensajes");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/contact-messages/${id}/read`);
    setMessages((m) => m.map((x) => (x.id === id ? { ...x, read: true } : x)));
  };

  const remove = async (id) => {
    await api.delete(`/contact-messages/${id}`);
    setMessages((m) => m.filter((x) => x.id !== id));
    toast.success("Mensaje eliminado");
  };

  if (loading) return <p className="text-zinc-500">Cargando…</p>;

  if (messages.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-zinc-300 p-16 text-center" data-testid="messages-empty">
        <Mail className="mx-auto text-zinc-300" size={40} />
        <p className="mt-4 text-zinc-500">Aún no hay mensajes de contacto.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="messages-list">
      {messages.map((m) => (
        <div key={m.id} className={`rounded-2xl border p-5 transition-colors ${m.read ? "border-zinc-200 bg-white" : "border-jauja-olive/40 bg-jauja-olive/5"}`} data-testid="message-item">
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <h4 className="font-semibold text-zinc-900">{m.name}</h4>
                {!m.read && <span className="rounded-full bg-jauja-olive px-2 py-0.5 text-[10px] font-bold uppercase text-white">Nuevo</span>}
              </div>
              <div className="mt-1 flex items-center gap-3 text-sm text-zinc-500 flex-wrap">
                <a href={`mailto:${m.email}`} className="hover:text-jauja-olive">{m.email}</a>
                {m.company && <span className="inline-flex items-center gap-1"><Building2 size={13} /> {m.company}</span>}
              </div>
              <p className="mt-3 text-sm text-zinc-700 whitespace-pre-wrap">{m.message}</p>
              <p className="mt-2 text-xs text-zinc-400">{new Date(m.created_at).toLocaleString("es-CL")}</p>
            </div>
            <div className="flex flex-col gap-2 shrink-0">
              {!m.read && (
                <button onClick={() => markRead(m.id)} data-testid={`mark-read-${m.id}`} className="inline-flex items-center gap-1 rounded-lg border border-zinc-200 px-3 py-1.5 text-xs text-zinc-600 hover:bg-zinc-50">
                  <MailOpen size={14} /> Leído
                </button>
              )}
              <button onClick={() => remove(m.id)} data-testid={`delete-msg-${m.id}`} className="inline-flex items-center gap-1 rounded-lg border border-red-200 px-3 py-1.5 text-xs text-red-500 hover:bg-red-50">
                <Trash2 size={14} /> Borrar
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
